export enum PanelName {
	CommentsPanel = 'comments-panel',
	DetailsPanel = 'details-panel',
}
